// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".px10 {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.hero-tool-container {\n  border-radius: 5px;\n  padding: 15px;\n  border: 1px solid #d9d9d9;\n  margin-bottom: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
